import type { AnySchema } from 'yup'
import { array, lazy, mixed, number, object, string } from 'yup'

import { DataAccessRequestStatus } from 'services/data-access-requests/enums'
import { buildStudyIdSchema } from 'services/shared/schemas/studyIdSchema'

/** Present key, value may be null. An omitted key fails. */
const nullableDefined = (schema: AnySchema) =>
  lazy((value: unknown) => {
    if (value === null) {
      return mixed().nullable().oneOf([null]).defined()
    }

    return schema
  })

const relatedDataAccessRequestUserSchema = object({
  _id: string().required(),
  email: string().required(),
  name: string().optional()
})
  .unknown(true)
  .required()

const relatedDataAccessRequestParticipantsSchema = object({
  matching: number().required(),
  total: number().required()
})
  .unknown(true)
  .required()

const relatedDataAccessRequestSchema = object({
  dataAccessRequestId: string().required(),
  studyId: nullableDefined(buildStudyIdSchema()),
  parentRequestId: nullableDefined(string().required()),
  requestedBy: nullableDefined(relatedDataAccessRequestUserSchema),
  requestedOn: string().required(),
  datasetName: string().required(),
  participants: nullableDefined(relatedDataAccessRequestParticipantsSchema),
  status: mixed<DataAccessRequestStatus>().oneOf(Object.values(DataAccessRequestStatus)).required()
})
  .unknown(true)
  .required()

/** GET `/v1/data-access-requests/verification/groups/{groupId}/requests`. */
export const getRelatedDataAccessRequestsResponseSchema = object({
  groupId: string().required(),
  data: array(relatedDataAccessRequestSchema).required()
})
  .unknown(true)
  .required()
